import SiteNavigation from '@legacy/components/Website/SiteNavigation'
import { useWebsite } from '@legacy/contexts/websiteContext'

import { NotFound } from 'app/components/NotFound'

export const DynamicPage = ({ routePath }: { routePath: string }) => {
  const { productSiteConfig } = useWebsite()

  const navigation = productSiteConfig.navigation.find((item) => item.path === routePath)
  const Component = navigation?.Component

  if (!Component) {
    return <NotFound />
  }

  return (
    <>
      {navigation?.showSiteNavigation && <SiteNavigation navigation={productSiteConfig.navigation} />}
      <Component />
    </>
  )
}
